export enum ButtonUnitShape {
	ROUNDED = 'shape-rounded',
	RECTANGLE = 'shape-rectangle',
}
